import React from 'react';
import bgPublic from '../../../assets/img/bg-public.png';
import grayBgTransparent from '../../../assets/img/gray-bg-transparent.png';

interface PricingModalProps {
	showPricingModal: boolean;
	setShowPricingModal: (show: boolean) => void;
	handleContactSales: () => void;
}

const PricingModal: React.FC<PricingModalProps> = ({
	showPricingModal,
	setShowPricingModal,
	handleContactSales
}) => {
	if (!showPricingModal) return null;

	return (
		<>
			<div className="modal-backdrop fade show" onClick={() => setShowPricingModal(false)}></div>
			<div className="modal fade show" style={{ display: 'block' }} tabIndex={-1}>
				<div className="modal-dialog modal-lg modal-dialog-centered" style={{ maxWidth: '60%' }}>
					<div className="modal-content" style={{
						position: 'relative',
						overflow: 'hidden'
					}}>
						{/* Background layers */}
						<div style={{
							position: 'absolute',
							top: 0,
							left: 0,
							right: 0,
							bottom: 0,
							backgroundImage: `url(${bgPublic})`,
							backgroundSize: 'cover',
							backgroundPosition: 'center center',
							backgroundRepeat: 'no-repeat',
							zIndex: 1
						}}></div>
						
						<div style={{
							position: 'absolute',
							top: 0,
							left: 0,
							right: 0,
							bottom: 0,
							backgroundImage: `url(${grayBgTransparent})`,
							backgroundSize: 'cover',
							backgroundPosition: 'right',
							backgroundRepeat: 'no-repeat',
							zIndex: 2
						}}></div>

						{/* Modal content */}
						<div className="d-flex justify-content-end align-items-end px-3 py-3" style={{ position: 'relative', zIndex: 3 }}>
							<button
								type="button"
								className="btn-close"
								onClick={() => setShowPricingModal(false)}
							></button>
						</div>
						<div className="modal-body" style={{ padding: '3rem 2rem', position: 'relative', zIndex: 3 }}>
							<div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center' }}>
								{/* Free Plan */}
								<div style={{ maxWidth: '400px', width: '400px', marginTop: '4rem' }}>
									<div style={{ 
										backgroundColor: 'white', 
										borderRadius: '20px', 
										borderTopRightRadius: '0px', 
										borderBottomRightRadius: '0px',
										padding: '2.5rem',
										paddingLeft: '8rem',
										boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
										border: '1px solid #e0e0e0',
										width: '100%'
									}}>
										<h3 style={{ 
											color: '#333', 
											fontSize: '1.5rem', 
											fontWeight: 'bold', 
											marginBottom: '2rem',
											textAlign: 'left'
										}}>
											FREE Subscription
										</h3>
										<ul style={{ 
											listStyle: 'none', 
											padding: 0, 
											margin: 0,
											marginLeft: 10
										}}>
											<li style={{ color: '#333', fontSize: '1rem', marginBottom: '1rem', lineHeight: '1.5' }}>
												Frequent Content updates
											</li>
											<li style={{ color: '#333', fontSize: '1rem', marginBottom: '1rem', lineHeight: '1.5' }}>
												Limited Access to Knowledge
											</li>
											<li style={{ color: '#333', fontSize: '1rem', marginBottom: '1rem', lineHeight: '1.5' }}>
												Only Limited Credits
											</li>
											<li style={{ color: '#333', fontSize: '1rem', marginBottom: '1rem', lineHeight: '1.5' }}>
												Not having History storage
											</li>
											<li style={{ color: '#333', fontSize: '1rem', marginBottom: '1rem', lineHeight: '1.5' }}>
												No User Management
											</li>
										</ul>
									</div>
								</div>

								{/* Enterprise Plan */}
								<div style={{ maxWidth: '400px', width: '400px' }}>
									<div style={{ 
										backgroundColor: '#26397E',
										borderRadius: '20px', 
										padding: '2.5rem',
										boxShadow: '0 4px 30px rgba(0, 60, 158, 0.3)',
									}}>
										<h3 style={{ 
											color: 'white', 
											fontSize: '1.5rem', 
											fontWeight: 'bold', 
											marginBottom: '2rem',
											textAlign: 'left'
										}}>
											ENTERPRISE Subscription
										</h3>
										<ul style={{ 
											listStyle: 'none', 
											padding: 0, 
											margin: 0
										}}>
											{[
												'Frequent Content updates',
												'Unlimited Access to Knowledge',
												'Best Practices in Cyber Security & Risk Management',
												'Framework Maturity Assessment',
												'Vendor Selection and Validation',
												'Cyber Governance and Risk',
												'Budget Matcher and Product Pricing Recommendations (Coming Soon)'
											].map((feature, index) => (
												<li key={index} style={{ color: 'white', fontSize: '1rem', marginBottom: '1rem', display: 'flex', alignItems: 'center', lineHeight: '1.5' }}>
													<span style={{ 
														display: 'inline-flex',
														alignItems: 'center',
														justifyContent: 'center',
														width: '20px',
														height: '20px',
														backgroundColor: '#28a745',
														borderRadius: '50%',
														border: '1px solid white',
														marginRight: '1rem',
														flexShrink: 0
													}}>
														<svg width="12" height="9" viewBox="0 0 12 9" fill="none">
															<path d="M1 4.5L4.5 8L11 1.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
														</svg>
													</span>
													{feature}
												</li>
											))}
										</ul>
									</div>
								</div>
							</div>
							
							{/* Contact Sales Button */}
							<div style={{ textAlign: 'center', marginTop: '3rem' }}>
								<button
									onClick={handleContactSales}
									style={{
										backgroundColor: '#26397E',
										color: 'white',
										border: 'none',
										borderRadius: '50px',
										padding: '15px 40px',
										fontSize: '1.1rem',
										fontWeight: 'bold',
										cursor: 'pointer',
										boxShadow: '0 4px 15px rgba(0, 60, 158, 0.3)',
										transition: 'all 0.3s ease'
									}}
									onMouseEnter={(e) => {
										const target = e.target as HTMLButtonElement;
										target.style.backgroundColor = '#5376F0';
										target.style.transform = 'translateY(-2px)';
									}}
									onMouseLeave={(e) => {
										const target = e.target as HTMLButtonElement;
										target.style.backgroundColor = '#26397E';
										target.style.transform = 'translateY(0)';
									}}
								>
									CONTACT SALES
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default PricingModal;